module.exports = __webpack_public_path__ + "img/2.403f889.svg";